import { __decorate } from "tslib";
import { AutoEncoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
export class GenericBalance extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.amountPaid = 0;
        this.amountOpen = 0;
        this.amountPending = 0;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], GenericBalance.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], GenericBalance.prototype, "organizationId", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 354 })
], GenericBalance.prototype, "amountPaid", void 0);
__decorate([
    field({ decoder: IntegerDecoder, field: 'amount' }),
    field({ decoder: IntegerDecoder, version: 354 })
], GenericBalance.prototype, "amountOpen", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], GenericBalance.prototype, "amountPending", void 0);
//# sourceMappingURL=GenericBalance.js.map